module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"malls":"Торговые центры","markets":"Рынки","shops":"Магазины"},"uk":{"malls":"Торгові центри","markets":"Ринки","shops":"Магазини"}}')
  delete Component.options._Ctor
}
